import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a95efef6d47130014d2343c_1788421220080_145458d6/contactsense/src/app/sign-up-login/components/AuthScreen.tsx");
